import { otherPricesRemapper } from '@elab/core/utils/PriceUtils';

import { reduceAction } from '../helpers';

import types from './types';
import helpers from './helpers';

export const defaultInitialState = {
    details: {
        code: null,
        isOutOfStock: true,
        isOfflineProduct: false,
        notifyMeUrl: '',
        smallPromotionBadge: null,
        variantCategoryName: null,
        hidePromotions: false,
        hideRoundel: false,
        isforbiddenProduct: false,
    },
    focused: false,
    loading: false,
    productCodeToBeRemoved: '',
    productDataForAddProductReview: {},
    showInformMeOnly: false,
    customCssLoaded: false,
    realTimeStockEnabled: true,
    deliveryDates: {
        homeDelivery: {
            message: '',
        },
        pickupInStore: {
            message: '',
            storeName: '',
        },
    },
    thresholdPromotion: null,
};

export const createReducers = (types, initialState = defaultInitialState) => {
    return (state = initialState, { type, payload }) => {
        switch (type) {
            case types.SET_PRODUCT:
                return {
                    ...state,
                    details: {
                        ...(payload || {}),
                        isOutOfStock: payload && helpers.isOutOfStock(payload),
                        smallPromotionBadge:
                            payload &&
                            (payload.isOosPromoBadge || !helpers.isOutOfStock(payload)) &&
                            helpers.getSmallPromotionBadge(
                                payload.promotions,
                                payload.markdownPromotion,
                                payload.useMarkDownPromotion,
                            ),
                        variantCategoryName:
                            payload &&
                            helpers.getVariantCategoryName(payload.variantMatrix, payload.code),
                        hidePromotions: payload && helpers.hidePromotions(payload),
                        hideRoundel: payload && helpers.hideRoundel(payload.masterBrand),
                        otherPrices: otherPricesRemapper(payload.otherPrices || []),
                        isforbiddenProduct:
                            payload &&
                            helpers.isForbiddenCountry(
                                payload.forbiddenCountries,
                                payload.deliveryCountry,
                            ),
                    },
                };

            case types.SET_LOADING:
                return reduceAction(state, 'loading', payload);

            case types.SET_FOCUSED:
                return reduceAction(state, 'focused', payload);

            case types.INIT_CRITEO: {
                return {
                    ...state,
                    criteoInitialized: true,
                };
            }

            case types.UPDATE_PRODUCT_WITH_VARIANT_DATA:
                return {
                    ...state,
                    details: {
                        ...state.details,
                        ...payload.variantData,
                        showPricePerUnit: payload.variantData.showPricePerUnit || null,
                        displayUnit: payload.variantData.displayUnit || null,
                        isOutOfStock: payload && helpers.isOutOfStock(payload.variantData),
                        code: payload.code,
                        pricePerUnit: payload.variantData.pricePerUnit || null,
                        topPromotion: payload.variantData.topPromotion || null,
                        dailyOffer: payload.variantData.dailyOffer || null,
                        couponCodeValue: payload.variantData.couponCodeValue || null,
                        smallPromotionBadge:
                            (payload.isOosPromoBadge ||
                                !helpers.isOutOfStock(payload.variantData)) &&
                            helpers.getSmallPromotionBadge(
                                payload.variantData.promotions,
                                payload.variantData.markdownPromotion,
                                payload.useMarkDownPromotion,
                            ),
                        variantCategoryName:
                            payload &&
                            helpers.getVariantCategoryName(
                                state.details.variantMatrix,
                                payload.code,
                            ),
                        hidePromotions:
                            payload &&
                            helpers.hidePromotions({
                                ...state.details,
                                ...payload.variantData,
                            }),
                        url: payload && helpers.updateVariantURL(state.details, payload.code),
                        otherPrices: otherPricesRemapper(payload.variantData.otherPrices || []),
                        isforbiddenProduct: helpers.isForbiddenCountry(
                            payload.variantData.forbiddenCountries,
                            payload.deliveryCountry,
                        ),
                    },
                };

            case types.UPDATE_PRODUCT_WITH_VARIANT_PRICE_DATA:
                return {
                    ...state,
                    details: {
                        ...state.details,
                        ...payload,
                    },
                };

            case types.RESET:
                return {
                    ...initialState,
                    popupVideo: state.popupVideo,
                };

            case types.SET_QUANTITY:
                return reduceAction(state, 'quantity', payload);

            case types.SET_PRODUCT_CODE_TO_BE_REMOVED:
                return reduceAction(state, 'productCodeToBeRemoved', payload);

            case types.SET_PRODUCT_DATA_FOR_ADD_PRODUCT_REVIEW:
                return reduceAction(state, 'productDataForAddProductReview', payload);

            case types.SET_INITIAL_QUANTITY:
                return reduceAction(state, 'initialQuantity', payload);

            case types.REMOVE_INITIAL_QUANTITY:
                delete state.initialQuantity;
                return { ...state };

            case types.SHOW_PRODUCT_VIDEO:
                return {
                    ...state,
                    popupVideo: {
                        videoId: payload.videoId,
                        videoType: payload.videoType,
                    },
                };

            case types.CLEAR_PRODUCT_VIDEO:
                return {
                    ...state,
                    popupVideo: {
                        videoId: null,
                        videoType: null,
                    },
                };

            case types.COLOR_VARIANTS_POPUP_UPDATE:
                return {
                    ...state,
                    colorVariantsPopup: {
                        ...state.colorVariantsPopup,
                        details: payload.details,
                        code: payload.code,
                    },
                };

            case types.COLOR_VARIANTS_POPUP_SUBMIT:
                return {
                    ...state,
                    details: {
                        ...state.details,
                        ...state.colorVariantsPopup.details,
                        code: state.colorVariantsPopup.code,
                    },
                };

            case types.COLOR_VARIANTS_POPUP_SYNC:
                return {
                    ...state,
                    colorVariantsPopup: {
                        details: {
                            images: state.details.images,
                        },
                        code: state.details.code,
                    },
                };

            case types.SHOW_INFORM_ME_ONLY:
                return reduceAction(state, 'showInformMeOnly', payload);

            case types.CUSTOM_CSS_LOADED:
                return reduceAction(state, 'customCssLoaded', payload);

            case types.SET_PRODUCT_HOME_DELIVERY_DATE:
                return {
                    ...state,
                    deliveryDates: {
                        ...state.deliveryDates,
                        homeDelivery: payload,
                    },
                };

            case types.SET_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE:
                return {
                    ...state,
                    deliveryDates: {
                        ...state.deliveryDates,
                        pickupInStore: payload,
                    },
                };

            case types.SET_BUNDLE_PRODUCT:
                return {
                    ...state,
                    details: {
                        ...(payload || {}),
                    },
                };

            case types.SET_THRESHOLD_PROMOTION_OBJECT:
                return {
                    ...state,
                    thresholdPromotion: payload,
                };

            default:
                return state;
        }
    };
};

export default createReducers(types);
